import FileModel from "@/model/file";
import api from "./api";

class FileApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async uploadImage(formData): Promise<any> {
    const response = await this.getHttp().post<any>("/images", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }
  async uploadFile(formData): Promise<FileModel> {
    const response = await this.getHttp().post<any>("/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }
  async download(id): Promise<any> {
    const response = await this.getHttp().get<any>(`/files/${id}`, {
      responseType: "blob",
    });
    return response;
  }
}
export default new FileApi();
